import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import clsx from 'clsx';

import CommonLoader from '../../../../../components/common-loader/CommonLoader';
import CommonTooltip from '../../../../../components/common-tooltip/CommonTooltip';
import CommonTooltipEllipses from '../../../../../components/common-tooltip-ellipses/CommonTooltipEllipses';

import scss from './AssetCard.module.scss';

function AssetCard({ title, meta, isLoading = false, onPreview, onDelete, children }) {
  const { t } = useTranslation('settings');
  const preview = children ?? <span className={scss.placeholder} />;

  return (
    <li className={clsx(scss.card, isLoading && scss.loading)} aria-busy={isLoading}>
      {onPreview ? (
        <button type='button' className={scss.preview} aria-label={title} disabled={isLoading} onClick={onPreview}>
          {preview}
        </button>
      ) : (
        preview
      )}

      <div className={scss.footer}>
        <span className={scss.text}>
          <CommonTooltipEllipses toolTipText={title} label={title} className={scss.title} />
          {meta ? <span className={scss.meta}>{meta}</span> : null}
        </span>

        {onDelete ? (
          <CommonTooltip title={t('delete')}>
            <span>
              <button
                type='button'
                className={scss.deleteButton}
                aria-label={t('delete')}
                disabled={isLoading}
                onClick={onDelete}>
                <Trash2 size={16} />
              </button>
            </span>
          </CommonTooltip>
        ) : null}
      </div>

      <CommonLoader isLoading={isLoading} width={28} />
    </li>
  );
}

export default AssetCard;
